import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ApplicationResponse } from "@src/common/domain/common.model"
import api from "@src/common/services/api.service"
import AppConstants from "@src/utils/app.constants"
import convertToForm from "@src/utils/payload-to-form-converter"
import YourProjects from "@src/views/dashboard/components/projects"
import { ProjectRef, ProjectStore } from "@src/views/dashboard/domain/projects.model"


export const fetchProjectList = createAsyncThunk<ProjectRef[], void>
  ("dashboard/fetchProjects",
  async () => {
      return [
        {
          ProjectName: "P1",
          Role: "Project Creator",
          Customer: "MARUTI",
        },
        {
          ProjectName: "P2",
          Role: "Individual",
          Customer: "HONDA",
        }]
    })

// const initialState = {
//     projects: [],
//     loading: false,
//     error: null,
//   };

//     export const uploadDashboard = createAsyncThunk<void, {
//         payload:  NewDashboardModelRef 
//     }>("dashboard/upload",
//         async (wrapper, thunkAPI) => {
//             try {
//                 const url = `${AppConstants.api}/users/new`
//                 const {
//                     payload
//                 } = wrapper

//                 const keys = Object.keys(payload) as Array<keyof NewDashboardModelRef >
//                 const formData = convertToForm(payload, keys)

//                 const response = await api.post<ApplicationResponse<void>>(url, formData, {
//                     headers: {
//                         "Content-Type": "multipart/form-data"
//                     }
//                 })

//                 return response.data.data
//             } catch (err: any) {
//                 if (!err.response) {
//                     return thunkAPI.rejectWithValue(err.response.data)
//                 }

//                 return thunkAPI.rejectWithValue({
//                     error: {
//                         message: "Network error",
//                         code: "NETWORK_ERROR",
//                         attributes: {}
//                     },
//                     status: "error",
//                     timestamp: new Date().toISOString()
//                 })
//             }
//         })

// export const {updateDashboardList} = dashboardSlice.actions;


const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {minimal: {status: "loading", error: null, data: []}} as ProjectStore,
  reducers: {
      
  },
  extraReducers: (builder) => {
    builder
        .addCase(fetchProjectList.pending, (state, action) => {
            state.minimal = {
                status: "loading",
                data: [],
                error: null
            }
        })
        .addCase(fetchProjectList.fulfilled, (state, action) => {
            state.minimal = {
                status: "idle",
                data: action.payload,
                error: null
            }
        })
        .addCase(fetchProjectList.rejected, (state, action) => {
            state.minimal = {
                status: "failed",
                data: [],
                error: action.error
            }
        })

}
})

export default dashboardSlice.reducer
